import { html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { repeat } from 'lit/directives/repeat.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import type { TrackingEventSource } from '../../../../app/package/base/service/tracking/tracking-service';
import type { PaymentTeaserItemProp } from '../../../../app/package/base/types';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import { dispatchCustomEvent } from '../../../base/package/util/event';
import styles from './ui-payment-teaser-modal.css?inline';
import '../../ui-payment-teaser-item/ui-payment-teaser-item';

const CName = 'ui-payment-teaser-modal';
/**
 * @fires close-payment-teaser-modal
 */
@customElement(CName)
export class UiPaymentTeaserModal extends UIModalServiceModal {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String }) trackingSource: TrackingEventSource;

  public close() {
    this._modalRef.value?.close();
  }

  render() {
    const paymentTeaserItems: PaymentTeaserItemProp[] = window.$app.appConfig.paymentTeaserItems;
    return html`
      <ui-modal
         ${ref(this._modalRef)}
        .onAction=${() => window.$app.product.gotoSignup(`${this.trackingSource}RegisterCTA`)}
        .actionButtonLabel=${window.$app.$t.get(I18n.base.register)}
        .onAltAction=${() => window.$app.product.gotoLogin(`${this.trackingSource}LoginCTA`)}
        .altActionButtonLabel=${window.$app.$t.get(I18n.base.login)}
        .onClosedAction=${() => dispatchCustomEvent(this, 'close-payment-teaser-modal')}
        role="dialog"
        aria-modal="true"
      >
        <div slot="title" class="title">${window.$app.$t.get(I18n.paymentTeaserModal.title)}</div>
        <div slot="main">
          ${repeat(
            paymentTeaserItems,
            (paymentTeaserItem: PaymentTeaserItemProp) => paymentTeaserItem.icon,
            (paymentTeaserItem: PaymentTeaserItemProp) =>
              html`<ui-payment-teaser-item class="payment-item" .item=${paymentTeaserItem}></ui-payment-teaser-item>`,
          )}
        </div>
      </ui-modal>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiPaymentTeaserModal;
  }
}
